export default class BrowserUtils {

  static isOldFirefox(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    const isFirefox = userAgent.indexOf('firefox') !== -1;

    if (isFirefox) {
      const indexOfFirefox = userAgent.indexOf('firefox');
      const [userAgentName, version] = userAgent.slice(indexOfFirefox).split('/');
      return parseInt(version, 10) === 34 || parseInt(version, 10) === 45;
    }

    return false;
  }

  static isWebView(): boolean {
    const userAgent = navigator.userAgent;

    const isAndroidWebView = /\bwv\b/.test(userAgent) || /Version\/[\d.]+.*Chrome\/[.0-9]+ Mobile/i.test(userAgent);

    const navigatorStandalone = (window.navigator as any).standalone;
    const isIosWebView = /iPhone|iPod|iPad/i.test(userAgent) && !navigatorStandalone && !/CriOS|FxiOS|OPiOS|mercury|Safari/i.test(userAgent);

    const isWebViewAndroidIndicator = typeof window['android'] !== 'undefined';

    if (isAndroidWebView || isWebViewAndroidIndicator || isIosWebView) {
      return true;
    }

    return false;
  }
}
